import { getField, updateField } from "vuex-map-fields";
import { airportService } from "../services";
import { EventBus } from "@/helpers";

export const airport = {
  namespaced: true,
  state: {
    airport: null,
    notice: false
  },
  actions: {
    getAirport(context, payload) {
      return airportService
        .getAirport(payload.airportId)
        .then(response => {
          context.commit("setAirport", {
            response
          });
        })
        .catch(error => {
          console.log("Error setAirport: ", error);
          EventBus.$emit("failedSetAirport", error);
        });
    },
    getNotice(context, code) {
      return airportService
        .getNotice(code)
        .then(response => {
          context.commit("setNotice", {
            response
          });
        })
        .catch(error => {
          console.log("Error getNotice: ", error);
          EventBus.$emit("failedGetNotice", error);
        });
    },
    uploadNotice(context, payload) {
      return airportService
        .uploadNotice(payload)
        .then(response => {
          context.commit("setNotice", {
            response
          });
        })
        .catch(error => {
          console.log("Error uploadNotice: ", error);
          EventBus.$emit("failedUploadNotice", error);
        });
    },
    deleteNotice() {
      return airportService
        .deleteNotice()
        .then()
        .catch(error => {
          console.log("Error deleteNotice: ", error);
          EventBus.$emit("failedDeleteNotice", error);
        });
    }
  },
  mutations: {
    updateField,
    setAirport(state, payload) {
      var data = JSON.parse(payload.response.data);
      state.airport = data;
      EventBus.$emit("setAirport");
    },
    setNotice(state, payload) {
      state.notice = payload.response.data.notice;
      EventBus.$emit("setNotice");
    }
  },
  getters: {
    getField
  }
};
